import { useContext, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import AuthContext from "../store/context/auth-context";

import { fetchCartData } from "../store/redux/cart/cart-actions";
import { fetchUserAdd } from "../store/redux/address/add-actions";
import { RESET_APP } from "../store/redux/rootActions";

import { localStoragePrefix } from "../utils/GeneralFunc";
import { detectUserCountry, fetchCountries } from "../store/redux/country/country-slice";

const useAppInit = () => {
  const dispatch = useDispatch();

  const authCtx = useContext(AuthContext);

  const isLoggedIn = authCtx.isLoggedIn;

  const cartChanged = useSelector(
    (state) => state.cart.changed
  );

  const addressChanged = useSelector(
    (state) => state.add.changed
  );

  const isFirstRender = useRef(true);

  // Initial Fetch
  useEffect(() => {
     dispatch(fetchCountries());
    
      dispatch(detectUserCountry());
    if (!isLoggedIn) return;


    dispatch(fetchCartData());
    dispatch(fetchUserAdd());
  }, [dispatch, isLoggedIn]);

  // Refetch Updated Data
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    if (cartChanged) {
      dispatch(fetchCartData());
    }

    if (addressChanged) {
      dispatch(fetchUserAdd());
    }
  }, [dispatch, cartChanged, addressChanged]);

  // Multi-tab Logout Sync
  useEffect(() => {
    const handleStorage = (event) => {
      if (
        event.key ===
          `${localStoragePrefix}userSessionId` &&
        event.oldValue &&
        !event.newValue
      ) {
        dispatch({ type: RESET_APP });

        authCtx.logout();
      }
    };

    window.addEventListener(
      "storage",
      handleStorage
    );

    return () => {
      window.removeEventListener(
        "storage",
        handleStorage
      );
    };
  }, [authCtx, dispatch]);
};

export default useAppInit;

// import { useContext, useEffect, useRef } from "react";
// import { useDispatch, useSelector } from "react-redux";

// import AuthContext from "../store/context/auth-context";

// import { fetchCartData } from "../store/redux/cart/cart-actions";
// import { fetchUserAdd } from "../store/redux/address/add-actions";
// import { RESET_APP } from "../store/redux/rootActions";

// const useAppInit = () => {
//   const dispatch = useDispatch();

//   const authCtx = useContext(AuthContext);

//   const isLoggedIn = authCtx.isLoggedIn;

//   const cartChanged = useSelector((state) => state.cart.changed);

//   const addressChanged = useSelector((state) => state.add.changed);

//   const isFirstRender = useRef(true);

//   // Initial Fetch
//   useEffect(() => {
//     if (!isLoggedIn) return;

//     dispatch(fetchCartData());
//     dispatch(fetchUserAdd());
//   }, [dispatch, isLoggedIn]);

//   // Refetch Updated Data
//   useEffect(() => {
//     if (isFirstRender.current) {
//       isFirstRender.current = false;
//       return;
//     }

//     if (cartChanged) {
//       dispatch(fetchCartData());
//     }

//     if (addressChanged) {
//       dispatch(fetchUserAdd());
//     }
//   }, [dispatch, cartChanged, addressChanged]);

//   // Multi-tab Logout Sync
//   useEffect(() => {
//     const handleStorage = (event) => {
//       if (event.key === "userSessionId" && event.oldValue && !event.newValue) {
//         dispatch({ type: RESET_APP });

//         authCtx.logout();
//       }
//     };

//     window.addEventListener("storage", handleStorage);

//     return () => {
//       window.removeEventListener("storage", handleStorage);
//     };
//   }, [authCtx]);
// };

// export default useAppInit;
